import { Component } from '@angular/core';

@Component({
  selector: 'fnsr-privacy',
  standalone: true,
  templateUrl: './privacy.component.html'
})
export class PrivacyComponent {

}
